"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts an IHttpOptions object to an array of query parameters
 * @param options
 */
exports.recordToParams = (record, params = [], path = "", isRoot = true) => {
    for (let [key, value] of Object.entries(record)) {
        let field = key;
        if (!isRoot) {
            field = `[${field}]`;
        }
        const _path = path + field;
        if (Array.isArray(value)) {
            // add each item to the params if the value is an array
            for (let i = 0; i < value.length; i++) {
                const item = value[i];
                if (typeof item === "object") {
                    exports.recordToParams(item, params, _path + `[${i}]`, false);
                }
                else {
                    params.push(`${_path}[${i}]=${encodeURIComponent(item)}`);
                }
            }
        }
        else if (value && typeof value === "object") {
            // allow nested fields
            exports.recordToParams(value, params, _path, false);
        }
        else {
            params.push(`${_path}=${encodeURIComponent(value)}`);
        }
    }
    return params.sort();
};
//# sourceMappingURL=record-to-params.utils.js.map